import React from "react";
import { Box, Typography } from "@mui/material";

const BlurredComponent = ({ children, isBlurred, message }) => {
    return (
        <Box sx={{ position: "relative", display: "inline-block" }}>
            {/* Размытие фона и надпись */}
            {isBlurred && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backdropFilter: "blur(3px)", // Размытие
                        backgroundColor: "rgba(255, 255, 255, 0.3)", // Полупрозрачный фон
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 2, // Выше контента
                    }}
                >
                    <Typography variant="h5" color="black">
                        {message}
                    </Typography>
                </Box>
            )}

            {/* Основной контент */}
            <Box sx={{ filter: isBlurred ? "blur(3px)" : "none", transition: "0.3s" }}>
                {children}
            </Box>
        </Box>
    );
};

export default BlurredComponent;
